/**
 * Normaliza un correo electrónico para registro e inicio de sesión:
 * - Elimina TODOS los espacios (incluidos tabuladores, saltos de línea,
 *   espacios duros y caracteres de ancho cero que llegan al copiar y pegar).
 * - Convierte el texto a minúsculas.
 *
 * Se usa tanto en los formularios como en las cargas masivas para que el
 * correo siempre viaje al backend en el mismo formato.
 */
export const normalizarCorreo = (correo) => {
  if (correo === null || correo === undefined) return "";
  return String(correo)
    .replace(/[\s\u200B-\u200D\uFEFF]+/g, "")
    .toLowerCase();
};

export default normalizarCorreo;
